import HttpClient from '../../../httpclient';
import Logger from '../../../../../helpers/logger';

function client(endpoint) {
  Logger.trace('Bootstrapping Endpoint', endpoint);
  return new HttpClient(endpoint);
}

export default client;
